export default function ThreeJSSettingsIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="10 10 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Advanced settings</title>
      <path
        d="M12.5 24.5H15"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M20 24.5H27.5"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      <path
        d="M12.5 16.5H20"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M25 16.5H27.5"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />

      <path
        d="M15 24.5A2.5 2.5 0 0 1 20 24.5A2.5 2.5 0 0 1 15 24.5Z"
        fill="none"
        stroke="currentcolor"
        strokeWidth="1.5"
      />
      <path
        d="M20 16.5A2.5 2.5 0 0 1 25 16.5A2.5 2.5 0 0 1 20 16.5Z"
        fill="none"
        stroke="currentcolor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
